import { createStore } from 'vuex';
//
const store = createStore({
  state: {
    readPosts: [],
  },
  mutations: {
    markAsRead(state, postId) {
      if (!state.readPosts.includes(postId)) {
        state.readPosts.push(postId);
      }
    },
  },
  actions: {
    markAsRead({ commit }, postId) {
      commit('markAsRead', postId);
    },
  },
  getters: {
    unreadPosts: (state) => (allPosts) => {
      return allPosts.filter(post => !state.readPosts.includes(post.id));
    },
  },
});

export default store;
